import axios from 'axios';

const endpoint = '/accounts';
const entity = 'account';
const key = 'name';
const parseParams = params => ((params.includes('?')) ? params.replace('?', '') : params);

const state = {
  data: {},
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  get({ commit }, params = '') {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}?${parseParams(params)}`)
        .then(({ data }) => {
          commit('data', data);
          resolve();
        })
        .catch(error => reject(error));
    });
  },
  find({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}/${rootGetters['global/account']}`)
        .then(({ data }) => {
          commit('data', data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  post({ dispatch }, body = {}) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpoint}`, body)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({
              creating: true, entity, key, data,
            }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  patch({ dispatch, rootGetters }, { id, body = {} }) {
    return new Promise((resolve, reject) => {
      if (!id) reject();
      axios.patch(`${endpoint}/${rootGetters['global/account']}`, body)
        .then(({ data }) => {
          resolve({
            creating: false, entity, key, data,
          });
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
